// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.section-title-divider {
  border: 0;
  border-top: 1px solid var(--app-legacy-card-divider);
  margin: 4px 0 4px;
}

:host(.section-title-first-in-card) {
  /* Compensa 2px do padding superior de 6px, inclusive nos usos com mt-0. */
  margin-top: -2px !important;
}

:host(.section-title-first-in-card) .section-title-divider {
  display: none;
}

.section-title {
  display: flex;
  align-items: center;

}

.section-title:before {
  content: "";
  display: inline-block;
  width: 24px;
  height: 8px;
  margin-right: 5px;
  background-color: var(--app-primary); /* Variável da cor */
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/section-title/section-title.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;EAC1E,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,oCAAoC,EAAE,oBAAoB;EAC1D,kBAAkB;AACpB","sourcesContent":[":host {\n  display: block;\n}\n\n.section-title-divider {\n  border: 0;\n  border-top: 1px solid var(--app-legacy-card-divider);\n  margin: 4px 0 4px;\n}\n\n:host(.section-title-first-in-card) {\n  /* Compensa 2px do padding superior de 6px, inclusive nos usos com mt-0. */\n  margin-top: -2px !important;\n}\n\n:host(.section-title-first-in-card) .section-title-divider {\n  display: none;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n\n}\n\n.section-title:before {\n  content: \"\";\n  display: inline-block;\n  width: 24px;\n  height: 8px;\n  margin-right: 5px;\n  background-color: var(--app-primary); /* Variável da cor */\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
